import Task from "../../../../model2/task/task"
import ActionEntity from "../../../../model2/automation/action-entity/action-entity"
import {Feature} from "../../../../gd/access-control/feature-access/const"
import {featureAccess} from "../../../../gd/access-control/feature-access/feature-access"

export function taskMore_getAvailableActions(task: Task): ActionEntity[] {
    return _.sortBy(gd.session.actions.filterForTask(task), (automation: ActionEntity) => {
        return automation.name.toLowerCase()
    })
}

export async function taskMore_runAction(task: Task, automation: ActionEntity) {
    if (!featureAccess(Feature.ACTIONS)) {
        return gd.modals.other.upgrade(Feature.ACTIONS)
    }

    const response  = await gd.api.Automation.runTaskAction(task.id, automation.id)
    const hasAccess = gd.ac.check.automation.view(automation.scope.projectId)

    if (response.result === 1) {
        gd.growl.actionApplied(automation.id, hasAccess)
    } else if (response.result === 2) {
        gd.growl.actionRunFailed(automation.id, response.errorMessage, hasAccess)
    }

    return response
}
